import { render, staticRenderFns } from "./OgHomeSpotlight.vue?vue&type=template&id=cdd022a6&scoped=true"
import script from "./OgHomeSpotlight.vue?vue&type=script&lang=js"
export * from "./OgHomeSpotlight.vue?vue&type=script&lang=js"
import style0 from "./OgHomeSpotlight.vue?vue&type=style&index=0&id=cdd022a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdd022a6",
  null
  
)

export default component.exports